import { loc } from "@/_services/localization"
import "@/_styles/ace-diff-editor.scss"
import React from "react"

class InputValidationComponent extends React.Component {
  render() {
    const { message, isWarning, errorHint, isSectionError } = this.props

    return (
      <span
        className={"input-validation-component " + (isWarning ? "validation-warning" : "validation-error") + (isSectionError ? " section-error" : "")}
      >
        <i className={`input-validation-icon icn-xs icn-exclamation-${isWarning ? "circle text-warning" : "triangle text-danger"}`} />
        {typeof message === "string" ? `${loc(message)}${errorHint ? ` ${errorHint}` : ""}` : Array.isArray(message) ? loc(...message) : null}
      </span>
    )
  }
}

export default InputValidationComponent
